import { AUTO_UPDATE_STORAGE_KEY } from "./autoUpdatePreference";
import { storageKey as actAsSessionStorageKey } from "./uiState/actAsUserAtom";

export const LOCAL_STORAGE_RESET_AT_KEY = "jm:localStorageResetAt";
// Advance this date when a release needs to clear saved browser settings again.
export const LOCAL_STORAGE_RESET_AT = "2026-10-14T00:00:00.000Z";

export function resetLocalStorageOnce(
  storage: Storage = localStorage,
): boolean {
  if (storage.getItem(LOCAL_STORAGE_RESET_AT_KEY) === LOCAL_STORAGE_RESET_AT) {
    return false;
  }

  const keys = Array.from({ length: storage.length }, (_, index) =>
    storage.key(index),
  );
  for (const key of keys) {
    // Firebase can persist authentication here when IndexedDB is unavailable.
    if (
      key !== null &&
      !key.startsWith("firebase:") &&
      key !== actAsSessionStorageKey &&
      key !== AUTO_UPDATE_STORAGE_KEY &&
      key !== LOCAL_STORAGE_RESET_AT_KEY
    ) {
      storage.removeItem(key);
    }
  }

  storage.setItem(LOCAL_STORAGE_RESET_AT_KEY, LOCAL_STORAGE_RESET_AT);
  return true;
}
